import axios from "axios";
import { DOMAIN_NAME } from "./config";

const appRequest = function (params) {
  const service = axios.create({
    baseURL: DOMAIN_NAME,
  });
  const token = sessionStorage.getItem("token");
  const datacenter = JSON.parse(localStorage.getItem("datacenter"));
  service.interceptors.request.use(
    (config) => {
      config.method = config.method || "POST";
      config.headers = {
        // ...params.headers,
        // accountId: '1716808941209390080',
        accountId: datacenter.accountId,
        tenantAlias: datacenter.accountNumber,
      };
      if (token) {
        config.headers.Accesstoken = token;
        //config.headers['access-Token'] = token
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  service.interceptors.response.use((response) => {
    const res = response.data;
    if (params.url === "kapi/v2/xn/xn_lssmcm/account/getPhoneCode") {
      sessionStorage.setItem("Traceid", response.headers.traceid || "");
    }
    //未知错误统一友好提示
    if (res.message && res.message.indexOf("TraceId") != -1) {
      const data = res.message.split("TraceId");

      return Promise.reject({
        message: "系统错误，请联系管理员！TraceId" + data[1].substr(0, 16),
      });
    }

    return response.data;
  });
  return service(params);
};

export default appRequest;
